<template>
  <Paginator class="my-4" v-bind="properties" @change-page="changePage" />
</template>

<script>
import Paginator from '@/components/Common/Paginator';

export default {
  name: 'GrouperPaginator',
  components: {
    Paginator
  },
  props: {
    totalPages: {
      type: Number,
      required: true,
      default: 0
    },
    currentPage: {
      type: Number,
      required: true,
      default: 0
    },
    namePage: {
      type: String,
      required: true
    }
  },
  computed: {
    nextPageLink() {
      return this.$urlBuilder(this.namePage, {
        id: this.$route.params.id,
        slug: this.$route.params.slug,
        page: this.currentPage + 1
      });
    },
    prevPageLink() {
      return this.$urlBuilder(this.namePage, {
        id: this.$route.params.id,
        slug: this.$route.params.slug,
        page: this.currentPage < 1 ? false : this.currentPage - 1
      });
    },
    properties() {
      return {
        currentPage: this.currentPage,
        totalPages: this.totalPages,
        nextPageLink: this.nextPageLink,
        prevPageLink: this.prevPageLink
      };
    }
  },
  methods: {
    changePage(page) {
      const path = this.$urlBuilder(this.namePage, {
        id: this.$route.params.id,
        slug: this.$route.params.slug,
        page
      });
      this.$router.push({ path });
    }
  }
};
</script>
